var trainee_access = (function($) {

	var anim_speed = 800;

	var _init = function() {
		if ($('body').hasClass('page-template-trainee-access')) {
			_setup_header_slider($('#trainee-access-header .owl-carousel'));
			_setup_gallery_events_tabs();
		}
	}

	var _setup_header_slider = function($carousel) {

		if ($carousel.length > 0) {
			$carousel.on('initialized.owl.carousel', function() {
				$carousel.find('.owl-item .item').show();
			});

			$carousel.owlCarousel({
				items : 1,
				loop : true,
				dots : true,
				arrows : false,
				autoplayTimeout : 7000,
				autoHeight: true
			});
		}
	};

	var _setup_gallery_events_tabs = function() {
		var $tabs = $('#trainee-access-gallery-event-tabs');

		if ($tabs.length > 0) {
			$tabs.find('a.tab-button').on('click', function(e) {
				e.preventDefault();

				_switch_gallery_events_tab($tabs, $(this).data('tab'));
			});
		}
	}

	var _switch_gallery_events_tab = function($tabs, tab) {
		if ($tabs.hasClass('animating') || $tabs.find('.tab-panel.' + tab).hasClass('active')) {
			return;
		}

		$tabs.find('.tab-button.active').removeClass('active');
		$tabs.find('.tab-button[data-tab=' + tab + ']').addClass('active');

		$tabs.addClass('animating');

		$tabs.find('.tab-panel.active')
			.slideUp(anim_speed / 2)
			.removeClass('active');

		setTimeout(function() {
			$tabs.find('.tab-panel.' + tab)
				.slideDown(anim_speed / 2)
				.addClass('active');
		}, anim_speed / 2);

		setTimeout(function() {
			$tabs.removeClass('animating');
		}, anim_speed);
	}

	$(document).ready(_init);

	return {};

})(jQuery);

module.exports = trainee_access;